import React from 'react';
import { Typography } from 'antd';
import List from './List';

export default function Certificates(): React.ReactNode {
  return (
    <div>
      <Typography.Title level={4}>
        Сертификаты
      </Typography.Title>
      <List />
    </div>
  );
}
